<div class="version-dialog">
<div class="row">
  <div class="col-12">
    <p class="version-dialog-header">Version {{ currentVersion.version }}</p>
    <button class="btn btn-sm close-btn disable-focus" (click)="closeDialog()" data-cy="close-version-dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
  <div class="row">
    <div class="col-lg-5">
      <div style="overflow-y: auto; overflow-x: hidden; max-height: 500px">
        <div class="versions">
          <div *ngFor="let version of versionsList">
            <div class="version-block" [ngStyle]="{ 'background': version.uuid == currentVersion.uuid ? '#dbf5ff' : 'white' }" (click)="setActiveVersion(version)">
              <div class="row">
                <div class="col-9">
                  <p style="font-size: 18px; font-weight: bold">Version {{ version.version }}</p>
                  <p style="font-size: 13px">
                    {{ setToLocalTime(version.created_at) }};
                    <b>{{ version.materialname }}</b>
                    <br />
                    <span *ngIf="version.CADrepair?.repaired" class="version-dialog-repairMessage"> CAD repair performed </span>
                  </p>
                </div>
                <div class="col-3 mt-2">
                  <mat-checkbox (change)="versionSelection(version.version, $event)"></mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row ml-4">
        <div class="col-2 version-delete">
          <button class="version-dialog_button-icon" mat-icon-button (click)="deleteVersion()" *ngIf="currentVersion && selectedVersions.length <= 1 && hasPermission">
            <mat-icon>delete</mat-icon>
          </button>
          <button class="version-dialog_button-icon" mat-icon-button disabled *ngIf="selectedVersions.length > 1" style="color: #21a0d2; opacity: 0.65">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="col-5 version-load">
          <button class="btn btn-sm version-dialog_button-main mt-2" (click)="loadVersion()" *ngIf="currentVersion && selectedVersions.length <= 1">Load version</button>
          <button class="btn btn-sm version-dialog_button-main mt-2" disabled *ngIf="selectedVersions.length > 1">Load version</button>
        </div>
        <div class="col-5 version-compare">
          <button
            class="btn btn-sm version-dialog_button-main mt-2"
            matToolTip="Tick the versions to compare"
            (click)="compareVersions()"
            *ngIf="selectedVersions.length > 1"
            data-cy="compare">
            Compare
          </button>
          <button class="btn btn-sm version-dialog_button-main mt-2" matToolTip="Tick the versions to compare" disabled *ngIf="selectedVersions.length <= 1">Compare</button>
        </div>
      </div>
    </div>
    <div class="col-lg-7">
      <div *ngIf="currentVersion && !errorVersion" class="row">
        <div class="col-lg-5" style="margin: 15% 0">
          <img *ngIf="imageSource" [attr.src]="imageSource" style="width: 100%; height: 100%; min-height: 44px" />
        </div>
        <div class="col-lg-7">
          <div  class="metrics-grid" *ngIf="projectReportData">
            <div class="metric-item text-center" *ngFor="let metrics of resultsData">
              <span class="metric-value"> {{ metrics.value }} {{ metrics.units }} </span>
              <br />
              <span class="metric-name">{{ metrics.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="errorVersion" class="row">
        <mat-icon class="col-3 error-icon">sentiment_dissatisfied</mat-icon>
        <div class="container col-7">
          <div class="arrow">
            <div class="outer"></div>
            <div class="inner"></div>
          </div>
          <div class="message-body">
            <p>
              There has been a problem with the CAD file.
              <br />
              Please check if there are any obvious errors in your CAD data or request support by clicking the 'support' button on the analysis page.
            </p>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
    </div>
  </div>
</div>
